import type { MapSelectionMode } from '../map'
import { mapAtom } from '../map'

export const getMapSelectionMode = (): Readonly<MapSelectionMode> => {
  return mapAtom.selectionMode
}
